import { printConstants } from '../constants';

export const printReducer = (state = {}, {type, payload = {}}) => {
    const {printID, frame} = payload;

    switch (type) {
        case printConstants.CREATE_PRINT_LIST:
            let {images, printed, rotate, imagesPerPage} = payload;

            return {
                list: {
                    ...state.list, 
                    [printID]: {
                        printed: printed,
                        images: images,
                        frame: frame,
                        rotate: rotate,
                        imagesPerPage: imagesPerPage
                    }
                }
            }

        case printConstants.DELETE_PRINT_LIST:
            if(!state.list[printID]) return state;

            const newList = {...state.list};
            delete newList[printID];

            return { 
                list: newList
            }

        case printConstants.SUCCESSFULLY_PRINT:
            if(!state.list[printID]) return state;

            const successfullyPrint = {...state.list[printID]};
            successfullyPrint.printed = true;

            return {
                list: {...state.list, [printID]: successfullyPrint}
            }

        case printConstants.UPDATE_BULK_IMAGES_PRINT_REQUEST: 
            return {
                ...state,
                updateBulkImagesPrintProcess: true
            }
    
        case printConstants.UPDATE_BULK_IMAGES_PRINT_SUCCESS: 
            return {
                ...state,
                updateBulkImagesPrintProcess: false,
                updateBulkImagesPrintError: false
            }

        case printConstants.UPDATE_BULK_IMAGES_PRINT_FAILURE: 
            return {
                ...state,
                updateBulkImagesPrintProcess: false,
                updateBulkImagesPrintError: true
            }

        default:
            return state;
    }
}

export default printReducer;


// WEBPACK FOOTER //
// ./src/reducers/print.js